function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18 18H14V25H18V18Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.4201 14.18L16.7101 6.30001C16.6172 6.20628 16.5066 6.13189 16.3847 6.08112C16.2628 6.03035 16.1321 6.00421 16.0001 6.00421C15.8681 6.00421 15.7374 6.03035 15.6155 6.08112C15.4937 6.13189 15.3831 6.20628 15.2901 6.30001L7.58012 14.19C7.39355 14.3781 7.24621 14.6013 7.14664 14.8468C7.04708 15.0923 6.99727 15.3551 7.00012 15.62V24C6.99934 24.5119 7.19489 25.0046 7.54649 25.3767C7.89809 25.7488 8.37898 25.9719 8.89012 26H12.0001V17C12.0001 16.7348 12.1055 16.4804 12.293 16.2929C12.4805 16.1054 12.7349 16 13.0001 16H19.0001C19.2653 16 19.5197 16.1054 19.7072 16.2929C19.8948 16.4804 20.0001 16.7348 20.0001 17V26H23.1101C23.6213 25.9719 24.1021 25.7488 24.4537 25.3767C24.8053 25.0046 25.0009 24.5119 25.0001 24V15.62C25.0009 15.0829 24.7929 14.5666 24.4201 14.18Z"
});

function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.16cf13ed.svg";
export { ForwardRef as ReactComponent };